import {
  Button,
  DatePicker,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Space,
} from "antd";
import TextArea from "antd/lib/input/TextArea";
import React, { useEffect, useState } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { FaInfoCircle, FaMinusCircle, FaPlus } from "react-icons/fa";
import DebounceSelect from "../../../components/common/DebounceSelect";
import { Districts } from "../../../constant/Districts";
import { Municipality } from "../../../constant/Municipalities";
import { api } from "../../../services/Api";

const { Option } = Select;

function CompanyForm({
  isModalVisible,
  handleCancel,
  handleOk,
  form,
  loading,
  initialValues,
  okText,
}) {
  const regOffice = Form.useWatch("regOffice", form);

  const renderExpiryDate = () => {
    return (
      <Form.Item label="Expiry Date" name="expiryDate">
        <DatePicker />
      </Form.Item>
    );
  };

  const [showPassword, setShowPassword] = useState(false);
  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const renderCROOptions = (param) => {
    switch (param) {
      case "Company Registrar Office":
        return (
          <>
            <Form.Item label="Username" name={["credential", "username"]}>
              <Input placeholder="Username" />
            </Form.Item>
            <Form.Item label="Password" name={["credential", "password"]}>
              <div style={{ display: "flex" }}>
                <Input
                  placeholder="Password"
                  type={showPassword ? "text" : "password"}
                />
                <Button
                  style={{
                    borderRadius: 8,
                    marginLeft: 10,
                    padding: 5,
                  }}
                  icon={
                    !showPassword ? <AiOutlineEye /> : <AiOutlineEyeInvisible />
                  }
                  onClick={toggleShowPassword}
                ></Button>
              </div>
            </Form.Item>
            <Form.Item
              label="Authorized Capital"
              name={["capital", "authorizedCap"]}
            >
              <Input placeholder="Authorized Capital" />
            </Form.Item>
            <Form.Item label="Issued Capital" name={["capital", "issuedCap"]}>
              <Input placeholder="Issued Capital" />
            </Form.Item>
            <Form.Item label="Paidup Capital" name={["capital", "paidupCap"]}>
              <Input placeholder="Paidup Capital" />
            </Form.Item>
            <Form.List name="shareHolders">
              {(fields, { add, remove }, { errors }) => (
                <>
                  {fields.map((field) => (
                    <Space key={field.key} align="baseline">
                      <Row>
                        <Form.Item label="Name" name={[field.name, "name"]}>
                          <TextArea
                            style={{
                              width: "16rem",
                            }}
                            rows={2}
                            placeholder="Shareholder Name"
                          />
                        </Form.Item>
                        <Form.Item
                          label="Citizenship:"
                          name={[field.name, "citizenshipNo"]}
                        >
                          <TextArea
                            style={{
                              width: "16rem",
                            }}
                            rows={2}
                            placeholder="Citizenship Number"
                          />
                        </Form.Item>
                      </Row>
                      <Row>
                        <Form.Item
                          label="Holding"
                          name={[field.name, "holding"]}
                        >
                          <TextArea
                            style={{
                              width: "16rem",
                            }}
                            rows={2}
                            placeholder="Shareholder Holding"
                          />
                        </Form.Item>
                        <Form.Item label="Ratio" name={[field.name, "ratio"]}>
                          <TextArea
                            style={{
                              width: "16rem",
                            }}
                            rows={2}
                            placeholder="Shareholder Ratio"
                          />
                        </Form.Item>
                        <FaMinusCircle onClick={() => remove(field.name)} />
                      </Row>
                    </Space>
                  ))}
                  <Form.Item>
                    <Button
                      type="dashed"
                      onClick={() => add()}
                      block
                      style={{
                        left: "50%",
                      }}
                      icon={<FaPlus />}
                    >
                      Add Shareholder
                    </Button>
                  </Form.Item>
                </>
              )}
            </Form.List>
          </>
        );
      case "Department of Commerce and Supply":
        return <>{renderExpiryDate()}</>;
      case "Department of Cottage and Small Industry":
        return <>{renderExpiryDate()}</>;

      case "Local Bodies":
        return <>{renderExpiryDate()}</>;

      case "Other Bodies":
        return <>{renderExpiryDate()}</>;

      case "Licensing Bodies":
        return <>{renderExpiryDate()}</>;

      default:
        return;
    }
  };

  const getUsers = async (queryString) => {
    return api
      .get("/users", {
        params: {
          "relation_role.slug": "user",
          firstName: encodeURI(`/${queryString}/i`),
        },
      })
      .then((body) =>
        body.data.docs.map((user) => ({
          label: `${user.firstName} ${user.lastName}`,
          value: user._id,
        }))
      );
  };

  const props = {
    listType: "picture",
    beforeUpload: (file) => {
      // uploadFile(file);
      return false;
    },
    showUploadList: false,
  };

  const [districtId, setId] = useState(1);
  const [districtname, setDistrictName] = useState();

  useEffect(() => {
    setDistrictName(
      Districts.filter((d, i) => d.id === initialValues?.address?.district)
        ?.label
    );
  }, [form, initialValues]);

  return (
    <Modal
      maskClosable={false}
      // title="Create a new company"
      visible={isModalVisible}
      onCancel={handleCancel}
      okText="Create"
      cancelText="Cancel"
      width={"30vw"}
      style={{ background: "white", top: "0px" }}
      className="global-modal"
      footer={[
        <Button
          loading={loading}
          key="submit"
          type="primary"
          onClick={handleOk}
        >
          {okText}
        </Button>,
      ]}
    >
      <div className="form-wrapper">
        <Form
          initialValues={{
            ...initialValues,
            address: {
              country: "Nepal",
              // district: initialValues?.address?.district
              //   ? {
              //       ...initialValues?.address?.district,
              //       label: `${initialValues?.address?.district}`,
              //       value: `${initialValues?.address?.district?.districtId}`,
              //     }
              //   : undefined,
              district: {
                label: districtname,
                value:
                  initialValues?.address?.district?.value ||
                  initialValues?.address?.district,
              },

              municipality: initialValues?.address?.municipality
                ? {
                    ...initialValues?.address?.municipality?.label,
                    label:
                      initialValues?.address?.municipality?.label ||
                      initialValues?.address?.municipality,
                    value: `${initialValues?.address?.municipality?.district_Id}`,
                  }
                : undefined,
            },
            user: initialValues?.user
              ? {
                  ...initialValues?.user,
                  label: `${initialValues?.user?.firstName}  ${initialValues?.user?.lastName}`,
                  value: `${initialValues?.user?._id}`,
                }
              : undefined,
          }}
          form={form}
          layout="vertical"
        >
          <Form.Item
            label="Company Name"
            name="name"
            required
            rules={[
              {
                required: true,
                message: "Please enter company name!",
              },
            ]}
          >
            <Input placeholder="Company Name" />
          </Form.Item>
          <Form.Item
            label="नेपाली नाम"
            name="nepaliName"
            rules={[
              {
                required: true,
                message: "कृपया कम्पनिको नेपालीमा नाम राख्नुहोस्",
              },
            ]}
            required
          >
            <Input placeholder="कम्पनिको नाम" />
          </Form.Item>
          <Form.Item
            label="Company Email"
            name="email"
            required
            rules={[
              {
                required: true,
                message: "Please enter company's email!",
              },
              {
                type: "email",
                message: "Please enter a valid email address !",
              },
            ]}
          >
            <Input type="email" placeholder="Company's Email" />
          </Form.Item>
          <Form.Item
            label="Company Phone Number"
            name="phone"
            required
            rules={[
              {
                required: true,
                message: "Please enter company's phone!",
              },
            ]}
          >
            <Input type="tel" placeholder="Company's Phone Number" />
          </Form.Item>
          {/* 
          {!initialValues && (
            <Form.Item
              label="Company Avatar"
              name="avatar"
              required
              rules={[
                {
                  required: true,
                  message: "Please select avatar of this company !",
                },
              ]}
            >
              <Upload.Dragger multiple {...props}>
                Drag files here Or
                <br />
                <br />
                <Button icon={<AiOutlineUpload />}>Upload</Button>
              </Upload.Dragger>
            </Form.Item>
          )} */}
          <Form.Item
            label="Company Pan Number"
            name="pan"
            required
            rules={[
              {
                required: true,
                message: "Please enter company's pan number !",
              },
            ]}
          >
            <Input type="number" placeholder="Company's Pan Number" />
          </Form.Item>
          <Form.Item
            label="Business Type"
            name="businessType"
            required
            rules={[
              {
                required: true,
                message: "Please enter company's business type !",
              },
            ]}
          >
            <Select>
              <Select.Option value="Solo">Solo</Select.Option>
              <Select.Option value="Partnership">Partnership</Select.Option>
              <Select.Option value="NGO/INGO">NGO/INGO</Select.Option>
              <Select.Option value="Cooperative">Cooperative</Select.Option>
              <Select.Option value="Company">Company</Select.Option>
              <Select.Option value="Others">Others</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item
            label="Tax Category"
            name="taxCategory"
            required
            rules={[
              {
                required: true,
                message: "Please enter company's tax category !",
              },
            ]}
          >
            <Select>
              <Select.Option value="D1">D1</Select.Option>
              <Select.Option value="D2">D2</Select.Option>
              <Select.Option value="D3">D3</Select.Option>
              <Select.Option value="D4">D4</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item
            label="Business Nature"
            name="businessNature"
            required
            rules={[
              {
                required: true,
                message: "Please enter company's business nature !",
              },
            ]}
          >
            <Select>
              <Select.Option value="Government sector">
                Government sector
              </Select.Option>
              <Select.Option value="Military sector">
                Military sector
              </Select.Option>
              <Select.Option value="International sector">
                International sector
              </Select.Option>
              <Select.Option value="Private sector">
                Private sector
              </Select.Option>
              <Select.Option value="Technology sector">
                Technology sector
              </Select.Option>
              <Select.Option value="Merchandising sector">
                Merchandising sector
              </Select.Option>
              <Select.Option value="Service sector">
                Service sector
              </Select.Option>
            </Select>
          </Form.Item>
          <Form.Item
            label="User"
            name="user"
            required
            rules={[
              {
                required: true,
                message: "Please enter user for this company !",
              },
            ]}
          >
            <DebounceSelect placeholder="Select User" fetchOptions={getUsers} />
          </Form.Item>
          <Form.Item
            label="Country"
            name={["address", "country"]}
            required
            rules={[
              {
                required: true,
                message: "Please enter company's country",
              },
            ]}
          >
            <Input placeholder="Company's Country" />
          </Form.Item>
          <Form.Item label="District" name={["address", "district"]}>
            <Select
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              value={districtId}
              onChange={(e) => setId(e)}
            >
              {Districts?.map((d, i) => {
                return (
                  <Option key={d.id} value={d.id}>
                    {d.label}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
          <Form.Item label="Municipality" name={["address", "municipality"]}>
            <Select
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {Municipality?.filter((el) => el.district_id === districtId)?.map(
                (m, i) => {
                  return (
                    <Option key={i} value={m.value}>
                      {m.label}
                    </Option>
                  );
                }
              )}
            </Select>
          </Form.Item>

          <br />
          <Form.List name="objectives">
            {(fields, { add, remove }, { errors }) => (
              <>
                {fields?.map((field) => (
                  <Space key={field.key} align="baseline">
                    <Form.Item name={[field.name]}>
                      <TextArea
                        className="text-text"
                        rows={2}
                        placeholder="Objective"
                      />
                    </Form.Item>
                    <FaMinusCircle onClick={() => remove(field.name)} />
                  </Space>
                ))}
                <Form.Item>
                  <Button
                    type="dashed"
                    onClick={() => add()}
                    block
                    style={
                      {
                        // left: "50%",
                      }
                    }
                    icon={<FaPlus />}
                  >
                    Add Objective
                  </Button>
                </Form.Item>
              </>
            )}
          </Form.List>

          <hr />

          <Form.Item
            label="Registration Office"
            name="regOffice"
            tooltip={{
              title: "Enter registration office",
              icon: <FaInfoCircle />,
            }}
          >
            <Select>
              <Select.Option value="Company Registrar Office">
                Company Registrar Office
              </Select.Option>
              <Select.Option value="Department of Commerce and Supply">
                Department of Commerce and Supply
              </Select.Option>
              <Select.Option value="Department of Cottage and Small Industry">
                Department of Cottage and Small Industry
              </Select.Option>
              <Select.Option value="Local Bodies">Local Bodies</Select.Option>
              <Select.Option value="Inland Department">
                Inland Revenue Department
              </Select.Option>
              <Select.Option value="Other Bodies">Other Bodies</Select.Option>
              <Select.Option value="Licensing Bodies">
                Licensing Bodies
              </Select.Option>
            </Select>
          </Form.Item>

          <Form.Item
            label="Registration Number"
            name="regNo"
            tooltip={{
              title: "Enter registration number",
              icon: <FaInfoCircle />,
            }}
          >
            <Input placeholder="Registration Number" />
          </Form.Item>

          <Form.Item
            label="Registration Date"
            name="regDate"
            rules={[
              {
                type: "object",
                required: false,
                whitespace: true,
              },
            ]}
          >
            <DatePicker />
          </Form.Item>
          {renderCROOptions(regOffice)}
          {/* <Form.Item label="Enabled" name="enabled" valuePropName="checked">
            <Switch checked />
          </Form.Item> */}
        </Form>
      </div>
    </Modal>
  );
}

export default CompanyForm;
